





























































































import { Component, Vue } from "vue-property-decorator";
import { namespace, State } from "vuex-class";
import BusinessRulesModule from "@/store/modules/business-rules";
import Draggable from "vuedraggable";
import { BusinessRulesState } from "@/models/business-rules/BusinessRulesState";
import { GroupData } from "@/models/business-rules/GroupData";
import { RulesSetData } from "@/models/business-rules/RulesSetData";
import { RulesSetReorderingPayload } from "@/models/business-rules/RulesSetReorderingPayload";

const businessRules = namespace(BusinessRulesModule.name);

@Component({
  name: "GroupOrder",
  components: { Draggable }
})

export default class GroupOrder extends Vue {
  // ===== Store ===== //
  @State("businessRules") private readonly businessRules!: BusinessRulesState;
  @businessRules.Action("getIndividualGroup") public getIndividualGroup!: (id: number) => void;
  @businessRules.Action("getIndividualRuleSet") public getIndividualRuleSet!: (ruleSet: RulesSetData) => void;
  @businessRules.Action("handleCurrentStep") public handleCurrentStep!: (step: number) => void;
  @businessRules.Action("handleResetRules") public handleResetRules!: () => void;
  @businessRules.Action("updateRuleSetOrder") public updateRuleSetOrder!: (payload: {} | RulesSetReorderingPayload[]) => void;

  // ===== Data ===== //
  public expansionLoading = false;
  public viewLoading = false;
  public panelIdx: undefined | null | number = 0;

  // ===== Methods ===== //
  public handleViewGroup(group: GroupData): void {
    this.getIndividualGroup(group.id);
    this.handleCurrentStep(2);
  }
  public async handleViewRuleset(ruleSet: RulesSetData): Promise<void> {
    this.viewLoading = true;
    await this.getIndividualRuleSet(ruleSet);
    this.handleCurrentStep(4);
    this.viewLoading = false;
  }
  public async updateSelectedGroup(group: GroupData): Promise<void> {
    this.expansionLoading = true;
    this.handleResetRules();
    this.handleCurrentStep(2);
    await this.getIndividualGroup(group.id);
    this.expansionLoading = false;
  }

  // ===== Computed ===== //
  get selectedPanel(): undefined | number | null {
    return !this.businessRules.selectedGroup ? undefined : this.panelIdx;
  }
  set selectedPanel(newVal: undefined | number | null) {
    this.panelIdx = newVal;
  }
  get dragOptions() {
    return {
      animation: 0,
      group: "description",
      disabled: false,
      ghostClass: "ghost"
    };
  }
  get selectedGroup() {
    return this.businessRules.selectedGroup;
  }
  get updatedRulesOrder() {
    return this.selectedGroup && this.selectedGroup!.rulesets ? this.selectedGroup!.rulesets.map((ruleset) => {
      return ruleset;
    }).sort((a, b) => a.order - b.order) : [];
  }
  set updatedRulesOrder(newVal) {
    const reorderedRuleSets = newVal.map((ruleset, idx: number) => { return { ...ruleset as object, order: idx + 1 }; });
    this.updateRuleSetOrder(reorderedRuleSets);
  }
}
